import type { FunctionComponent } from 'react';
import { mapIconName } from '../../../app-kit/helpers/mapIconName';
import { mapLinkIconPlacement } from '../../../app-kit/helpers/mapLinkIconPlacement';
import { mapButtonVariant } from '../../../app-kit/helpers/mapButtonVariant';

import { HeaderCtas } from './HeaderCtas';
import { WebLink } from '../../../app-kit/components/WebLink/types';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { useHeaderCtasBySlugQueryContent } from '../../hooks/useHeaderCtasBySlugQuery';
import { mapHeaderCtasV2 } from './helpers/mapHeaderCtasV2';
import { HeaderCtasV2 } from './HeaderCtasV2';

export const HeaderCtasWithData: FunctionComponent = () => {
  const headerCtasResponse = useHeaderCtasBySlugQueryContent();
  if (!headerCtasResponse) return null;

  const { ctas, ctasV2 } = headerCtasResponse;
  if (!ctas && !ctasV2) return null;

  if (ctasV2 && ctasV2.items) {
    return <HeaderCtasV2 ctas={mapHeaderCtasV2(ctasV2.items)} />;
  }

  if (ctas && ctas.items) {
    const mappedCtas = ctas.items.map((cta) => {
      if (cta.__typename === 'WebLink') {
        const ctaAsWebLink = {
          ...cta,
          variant: mapApiWeblinkVariantToLinkVariant(cta.variant),
        } as WebLink;
        return ctaAsWebLink;
      }
      return {
        icon: mapIconName(cta.iconName),
        iconPlacement: mapLinkIconPlacement(cta.iconPlacement),
        sizeVariant: cta.sizeVariant ?? undefined,
        variant: mapButtonVariant(cta.buttonVariant),
        text: cta.text,
        ctaVariant: cta.ctaVariant,
      };
    });

    return <HeaderCtas headerCtas={mappedCtas} />;
  }
};
